import { Controller } from "@hotwired/stimulus"

const SCROLL_KEY = "side-filter-scroll"
const SUBMIT_DEBOUNCE_MS = 100

export default class extends Controller {
  static values = { deferred: Boolean }

  #submitTimer

  connect() {
    this.element.classList.remove("animate-pulse", "pointer-events-none")
    document.addEventListener("turbo:before-cache", this.#onBeforeCache)
    this.#restoreScroll()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.#onBeforeCache)
  }

  change() {
    if (this.deferredValue) return
    clearTimeout(this.#submitTimer)
    this.#submitTimer = setTimeout(() => this.element.requestSubmit(), SUBMIT_DEBOUNCE_MS)
  }

  openFollowLogin() {
    const title = document.querySelector("#session-body .modal-title")
    if (title) title.innerHTML = "Login to follow artists"
  }

  applyFilters() {
    this.element.requestSubmit()
  }

  #restoreScroll() {
    const saved = sessionStorage.getItem(SCROLL_KEY)
    if (!saved) return
    sessionStorage.removeItem(SCROLL_KEY)
    const container = document.getElementById("listings-side-filter")
    if (container) container.scrollTop = parseInt(saved)
  }

  // Turbo caches the live DOM for back/forward; keep that snapshot matching the
  // URL by saving the scroll position and dropping any unsubmitted input edits.
  #onBeforeCache = () => {
    this.#persistScroll()
    this.#resetInputsToServerState()
  }

  #persistScroll() {
    const container = document.getElementById("listings-side-filter")
    if (container?.scrollTop > 0) sessionStorage.setItem(SCROLL_KEY, container.scrollTop)
  }

  #resetInputsToServerState() {
    this.element.querySelectorAll("input[type='checkbox'], input[type='radio']").forEach((input) => {
      input.checked = input.defaultChecked
    })
    this.element.querySelectorAll("input[type='text'], input[type='number']").forEach((input) => {
      input.value = input.defaultValue
    })
  }
}
